import { IsNotEmpty, IsString } from 'class-validator';
import { NorthCapitalAccountId } from '../models/account-id';

export class DeleteAccountRequest {
    @IsString()
    @IsNotEmpty()
    accountId: NorthCapitalAccountId;
}
